/**
 * Axios Interceptors Configuration
 * Sets up global request interceptors for handling authentication and credentials
 */

import axios from "axios";

/**
 * Request interceptor for axios
 * Automatically adds authorization token and credentials to all requests
 * @param {Object} config - Axios request configuration object
 * @returns {Object} Modified request configuration
 */
axios.interceptors.request.use(
  (config) => {
    const tokenData = JSON.parse(localStorage.getItem("userInfo"));
    const token = tokenData?.token;

    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.withCredentials = true;
    return config;
  },
  /**
   * Error handler for request interceptor
   * @param {Error} error - Error object from failed request
   * @returns {Promise} Rejected promise with error
   */
  (error) => {
    return Promise.reject(error);
  },
);
